import React, { useState, useEffect } from 'react';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg navbar-light bg-white sticky-top ${isScrolled ? 'shadow-sm' : ''}`}>
      <div className="container">
        <a className="navbar-brand fw-bold text-primary" href="#top">Bookolica</a>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarContent" 
          aria-controls="navbarContent" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link" href="#top">HOME</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#il-libro">LIBRI</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#chi-siamo">CHI SIAMO</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 